export default function currentUserToMembership(currentUser) {
    return currentUser ? {
      // NOTE: No membership id.
      owner: currentUser,
      organization: currentUser.organization || {},
      report: true,
      manage_overview: true,
      manage_add_ons: true,
      promote: true,
      all_listings: true,
      event_ids: [],
      manage_fee_presets: true,
      is_current_user: true,
    } : {};
}
